import * as React from 'react';
import { ExternalLink } from '@components/atoms';
import { Button, ButtonSize, ButtonVariant } from '@components/molecules';
import { cn } from '@utils';

interface IExternalActionLinkBaseProps {
	href?: string;
	testId?: string;
	className?: string;
	iconClassName?: string;
	size?: ButtonSize;
	onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

type IExternalActionLinkProps =
	| (IExternalActionLinkBaseProps & { label: string; ariaLabel?: string })
	| (IExternalActionLinkBaseProps & { label?: undefined; ariaLabel: string });

function ExternalActionLinkComponent({
	href,
	label,
	ariaLabel,
	testId,
	className,
	iconClassName,
	size = ButtonSize.SM,
	onClick,
}: IExternalActionLinkProps): React.ReactElement {
	return (
		<Button asChild variant={ButtonVariant.HYPERLINK} size={size} className={className}>
			<a
				href={href}
				target="_blank"
				rel="noopener noreferrer"
				data-testid={testId}
				aria-label={ariaLabel}
				onClick={onClick}
			>
				{label}
				<ExternalLink className={cn('inline-flex h-4 w-4', label && 'ml-1.5', iconClassName)} />
			</a>
		</Button>
	);
}

const ExternalActionLink = React.memo(ExternalActionLinkComponent);
ExternalActionLink.displayName = 'ExternalActionLink';

export { ExternalActionLink };
export type { IExternalActionLinkProps };
